/* eslint-disable max-lines-per-function */
import "./StepNumber.scss";
import { cn } from "tailwind-variants";

export default function StepNumber({
  content,
  stepNumber = 1,
  showTopBorder = false,
  compact = false,
  children,
  ...restProps
}) {
  return (
    <div
      {...restProps}
      className={cn(
        "step-number scope-81d5256b",
        {
          "step-number--with-line": showTopBorder,
          "step-number--compact": compact
        },
        restProps.className
      )}
    >
      <div className="step-number__content scope-81d5256b">
        {" "}
        Step {stepNumber}:{" "}
        <span className="step-number__content--light scope-81d5256b">{content}</span>
      </div>
      {children}
    </div>
  );
}
